import { isValidPhoneNumber } from "react-phone-number-input";
import { object, string, ValidationError } from "yup";

import { TUserRole } from "@/features/Auth";

export const createUserValidation = object().shape({
  name: string().matches(/^\S+$/, "whiteSpace").required(),
  surname: string().matches(/^\S+$/, "whiteSpace").required(),
  phone: string()
    .test("phone-validation", (value, context) => {
      if (!value) {
        return true;
      }
      return isValidPhoneNumber(value) || new ValidationError("phone", value, context.path);
    }),
  email: string().trim().email()
    .required(),
  role: string<TUserRole>().required(),
});
